export default "__VITE_PUBLIC_ASSET__225db1fb__"